import * as React from 'react';
import '../css/rap.sass';
import RAPPopup from './RAPPopup';
import Shoe from './Shoe';
import Hat, { HatType } from './Hat';
import fixRapOnScroll from '../utils/fixRapOnScroll';

export interface AdditionalDetails {
  label?: string;
  description?: string | React.ReactNode;
}
interface RAPProps {
  children: React.ReactNode;
  elementsCoveringRAP?: string; // This takes the ids of the elements in csv which are covering RAP and need to be moved
  elementRefToPositionRAP?: string;
  theme?: 'night' | 'day';
  additionalDetails?: AdditionalDetails;
  toggleRAP?: boolean;
  onRAPPopupClose?: Function;
  pinnedPosition?: 'LOAD' | 'SCROLL';
  scrollRAPStopId?: string;
  scrollRAPTriggerId?: string;
  fixPositionOnScroll?: boolean;
  hat?: HatType;
}

interface RAPState {
  toggleRAP?: boolean;
}
export default function RAP(props: RAPProps) {
  const [state, setState] = React.useState<RAPState>({});
  const {
    elementsCoveringRAP = 'tfs_invite_DockedInvite_container,tfs_invite_DockedInviteCallaction_container,tfsMinimizedInviteContainer,asapp-chat-sdk-badge',
    elementRefToPositionRAP = 'upcomingPayments',
    theme = 'day',
    pinnedPosition = 'SCROLL',
    scrollRAPTriggerId = 'rap-container',
    scrollRAPStopId = 'campfirefooter',
    fixPositionOnScroll = false
  } = props;
  const elementIds: string[] = elementsCoveringRAP.split(',');

  // adjusting the position of chat icon
  const adjustChatElementsPosition = (adjustChatIcon: boolean) => {
    const chatElements: any[] = elementIds.map(elemId =>
      document.getElementById(elemId)
    );
    if (chatElements) {
      chatElements.forEach(chatElement => {
        if (chatElement) {
          if (adjustChatIcon) {
            if (document.getElementsByClassName('hatDetails')[0])
              chatElement.classList.add('adjustChatPositionWithHat');
            else chatElement.classList.add('adjustChatPosition');
          } else {
            chatElement.classList.remove('adjustChatPosition');
            chatElement.classList.remove('adjustChatPositionWithHat');
          }
        }
      });
    }
  };

  // Observer callback function to execute when new chat element are added in DOM
  const domMutationCallback = (mutations: any) => {
    mutations
      .map((mutation: any) => mutation.addedNodes)
      .forEach((node: any) => {
        if (
          node[0] &&
          elementIds.indexOf(node[0].id) !== -1 &&
          (!node[0].classList.contains('adjustChatPositionWithHat') ||
            !node[0].classList.contains('adjustChatPosition'))
        ) {
          if (document.getElementsByClassName('hatDetails')[0])
            node[0].classList.add('adjustChatPositionWithHat');
          else node[0].classList.add('adjustChatPosition');
        }
      });
  };

  const checkAndAdjustChatElmsPosition = () => {
    const existingChatElms: any[] = elementIds
      .map(elemId => document.getElementById(elemId))
      .filter(elm => elm !== null);
    if (existingChatElms.length > 0) {
      adjustChatElementsPosition(true);
    } else {
      // node that will be observed for mutations
      const targetNode: any = document.getElementsByTagName('body');

      // Options for the observer (which mutations to observe)
      const config = {
        attributes: false,
        childList: true,
        subtree: true,
        attributeOldValue: false,
        characterDataOldValue: false
      };
      // eslint-disable-next-line no-undef
      const domElementMutationObserver = new MutationObserver(
        domMutationCallback
      );
      // Start observing the target node for configured mutations
      domElementMutationObserver.observe(targetNode[0], config);
    }
  };

  React.useEffect(() => {
    if (props.toggleRAP !== undefined) {
      checkAndAdjustChatElmsPosition();
      setState({ ...state, toggleRAP: props.toggleRAP });
    }
  }, [props.toggleRAP]);

  const toggleRAP = () => {
    setState({ ...state, toggleRAP: true });
  };

  if (state.toggleRAP) {
    document.body.style.overflow = 'hidden';
    adjustChatElementsPosition(false);
  } else {
    document.body.removeAttribute('style');
  }

  let scrollPosition: number;
  const listenScrollEvent = () => {
    const refElement = document.getElementById(elementRefToPositionRAP);
    if (refElement !== null) {
      scrollPosition = refElement.offsetTop + refElement.offsetHeight;
    }
    const element = document.getElementById('rapMobileAction');
    if (element !== null) {
      if (window.scrollY >= scrollPosition) {
        element.classList.add('mobileDisplay');
        const RAPButton = document.getElementById('RAPButton');
        if (RAPButton !== null) {
          RAPButton.onclick = toggleRAP;
        }
        adjustChatElementsPosition(true);
      } else {
        element.classList.remove('mobileDisplay');
        adjustChatElementsPosition(false);
      }
    }
  };

  const scrollRap = () => {
    if (fixPositionOnScroll) {
      fixRapOnScroll('rap-container', scrollRAPStopId, scrollRAPTriggerId);
    }
  };
  React.useEffect(() => {
    scrollRap();
    window.addEventListener('scroll', scrollRap, true);
    return () => window.removeEventListener('scroll', scrollRap, true);
  }, []);

  React.useEffect(() => {
    if (pinnedPosition === 'SCROLL') {
      window.addEventListener('scroll', listenScrollEvent);
    }
    return () => window.removeEventListener('scroll', listenScrollEvent);
  }, [pinnedPosition]);

  return state.toggleRAP ? (
    <RAPPopup
      toggleRAP={state.toggleRAP}
      onClose={() => {
        setState({ ...state, toggleRAP: false });
        if (props.onRAPPopupClose !== undefined) {
          props.onRAPPopupClose();
        }
      }}
    >
      {props.children}
    </RAPPopup>
  ) : (
    <div className="rap-container" id="rap-container">
      {props.hat && (
        <div className="rap-hat">
          <Hat theme={theme} hat={[props.hat]} />
        </div>
      )}
      <div className={`rap ${theme}`}>{props.children}</div>
      {(props.additionalDetails || props.hat) && (
        <div className="hatDetails">
          <Hat
            theme={theme}
            // @ts-ignore
            hat={[
              props.additionalDetails
                ? {
                    type: 'default',
                    message: (
                      <span className="hatLabel">
                        {props.additionalDetails.label}&nbsp;
                        {props.additionalDetails.description}
                      </span>
                    )
                  }
                : undefined,
              props.hat
            ].filter(hat => !!hat)}
          />
        </div>
      )}
      {props.additionalDetails && (
        <div className="shoeDetails">
          <Shoe theme={theme}>
            <div className="label">{props.additionalDetails.label}</div>
            <div className="description">
              {props.additionalDetails.description}
            </div>
          </Shoe>
        </div>
      )}
    </div>
  );
}
